<template>
    <div id="page" :class="[isLight ? 'lightmode' : 'darkmode']">
        <div v-if="isMenuShown" class="darker-film" @click="toggleMenuMobile"></div>
        <sidebar-navigator @change-theme="changeTheme" 
                        @toggle-menu-mobile="toggleMenuMobile" 
                        @change-calc="changeCalc" 
                        :menu-shown="isMenuShown"
                        :dark-mode="isLight"
                        :selected-calc="selectedCalc"/>
        <navigation-bar @toggle-menu-mobile="toggleMenuMobile" @change-theme="changeTheme" :dark-mode="isLight"/>
        <main :class="[isLight ? 'lightmode' : 'darkmode']">
            <article>
                <header>
                    <h1>The time calculator</h1>
                    <p style="margin-top:0;">a Untitled 9 product</p>
                </header>
                <section id="general-info">
                    <h2>What is the Time Calculator</h2>
                    <p>The Time Calculator is an online tool where you can perform time-related operations.
                        My Time Calculator was created to solve a problem I found with other similar tools -
                        they were all scattered,sometimes grouped but only a few of them.The Untitled 9 Time 
                        Calculator has multiple tools:
                    </p>
                    <ul>
                        <li><a href="#time-calculators">Time calculators</a></li>
                        <li><a href="#calendar-converter">Calendar converter</a></li>
                        <li><a href="#timezone-converter">Timezone converter</a></li>
                        <li><a href="#unit-converter">Unit converter</a></li>
                    </ul>
                </section>
                <section id="time-calculators">
                    <h2>Time calculators</h2>
                    <p>The first tool is a simple time calculator.It has multiple operations - Difference and Sum,
                        as well as calculator of average value and finder of lowest and highest values.The calculator
                        handles overflow in order to display the values correctly (i.e. 1 year instead of 365 days or 
                        12 months,1 day and 2 hours instead of 26 hours).
                    </p>
                    <h3>Operations</h3>
                    <p>You can select what operation you want to perform with time values from the "Operation" selection 
                        in the "Settings" tab.Here you have the 5 operations listed above.Particular attention should be 
                        given to the Difference operation.In case of usage of more than 2 time values,the Difference is 
                        calculated cumulatively,starting from the first value and subtracting each from the result of the 
                        previous subtraction.All inputs that are not filled are treated as zero values.
                    </p>
                    <p>The selected operation is indicated at the top of the calculator.</p>
                    <h3>Units</h3>
                    <p>The Time Calculator offers the ability to calculate using different units,not just minutes and hours.
                        It also has unit Scopes.A scope is a set of units with a specific relationship between each.You can 
                        select which scope to use from the "Scope" selection in the "Settings" tab.There are currently 4 scopes:
                    </p>
                    <ul>
                        <li>ISO Standard</li>
                        <li>Banking Standard</li>
                        <li>Business</li>
                        <li>Julian</li>
                    </ul>
                    <p>What sets apart these scopes is the relationship between units - how many of a certain unit fit in 
                        another - particularly how many days there are in a month and how many in a year,but some also feature 
                        unique relationships like the Business standard.Below are the conversion tables,each of these tables 
                        is present in the "Conversions" tab,with a label indicating the selected scope.
                    </p>
                    <h4 id="iso-standard">ISO Standard</h4>
                    <table :class="[isLight ? 'lightmode' : 'darkmode']">
                        <thead>
                            <tr>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']" style="width:20%;">Unit</th>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']">Conversion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 year</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">12 months or 365,2425 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 month</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">30,436875 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 week</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">7 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 day</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">24 hours or 1440 minutes or 86400 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 hour</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 minutes or 3600 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 minute</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 second</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">Base unit</td>
                            </tr>
                        </tbody>
                    </table>
                    <h4>Banking Standard</h4>
                    <table :class="[isLight ? 'lightmode' : 'darkmode']">
                        <thead>
                            <tr>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']" style="width:20%;">Unit</th>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']">Conversion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 year</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">12 months or 360 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 month</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">30 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 week</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">7 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 day</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">24 hours or 1440 minutes or 86400 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 hour</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 minutes or 3600 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 minute</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 second</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">Base unit</td>
                            </tr>
                        </tbody>
                    </table>
                    <h4>Business</h4>
                    <table :class="[isLight ? 'lightmode' : 'darkmode']">
                        <thead>
                            <tr>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']" style="width:20%;">Unit</th>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']">Conversion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 year</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">12 months or 260 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 month</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">21,66667 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 week</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">5 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 day</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">8 hours or 480 minutes or 28800 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 hour</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 minutes or 3600 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 minute</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 second</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">Base unit</td>
                            </tr>
                        </tbody>
                    </table>
                    <h4>Julian Calendar</h4>
                    <table :class="[isLight ? 'lightmode' : 'darkmode']">
                        <thead>
                            <tr>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']" style="width:20%;">Unit</th>
                                <th :class="[isLight ? 'lightmode' : 'darkmode']">Conversion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 year</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">12 months or 365,25 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 month</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">30,4375 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 week</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">7 days</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 day</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">24 hours or 1440 minutes or 86400 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 hour</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 minutes or 3600 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 minute</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">60 seconds</td>
                            </tr>
                            <tr>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">1 second</td>
                                <td :class="[isLight ? 'lightmode' : 'darkmode']">Base unit</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>You will also find the selection of units.You can either calculate in individual uits or select 
                        sets of them and calculate complex and more realistic time values.You will also find a check box,
                        checking this will synchronise all inputs and the output together,locking you in a specific set of 
                        units,which you can select from the selection immediately below in the "Settings" tab.If you uncheck it
                        you'll be able to set each individual input's units by clicking on the arrow pointing down on the right
                        side of each input.You'll also be able to choose what units to visualise the result in,from the same 
                        selection of units.
                    </p>
                    <h3>Other</h3>
                    <p>You can add and remove inputs.To add an input click the "Add input" button right below the last input in 
                        the list.To remove an input,click on the X button to the right of the input you wish to remove.There may be
                        at least 2 inputs.The input removal buttons will appear for each input only if there are 3 or more inputs.
                    </p>
                    <p>To calculate,click the big green button.The result will be show instantly in the result box.The result is 
                        selectable.The result box features a legend indicating the scope and units the result will be show in.
                    </p>
                </section>
                <section id="calendar-converter">
                    <h2>Calendar converter</h2>
                    <p>The calendar converter allows you to convert a date from one calendar to another and find out what 
                        date it is today in other calendars.It features 4 calendars - Gregorian,Islamic,Persian and Hebrew.
                        The day and month inputs are selections,allowing you to only type in the allowed values,while the year 
                        field is a free number field,allowing you to type in whatever number you want.It accounts for leap years 
                        and other features of each of these calendars.The input fields are pre-filled with today's date and the 
                        Gregorian calendar in the "From" field.
                    </p>
                </section>
                <section id="timezone-converter">
                    <h2>Timezone converter</h2>
                    <p>The timezone converter allows you to convert a time to the time it would be in another place on the planet.
                        It features a toggle between AM/PM and 24-hour modes and daylight savings shifts.The input fields are 
                        pre-filled with the current time your computer and the timezone in the "From" selection is the timezone of 
                        the computer.All the inputs are selections so you can type in valid values.
                    </p>
                    <h3>Timezone selections</h3>
                    <p>There are 2 selections - "From" timezone and "To" timezone.The selection buttons feature some city,country 
                        and/or territory names as well as the name of the timezone itself in various abbreviations and the UTC offset.
                    </p>
                    <p>When clicking these buttons,a large menu appears on screen.You can select an option from the ones presented.
                        The "From" menu features both the timezone in their standard or "winter" mode and their daylight savings or 
                        "summer" counterparts.Depending on whether the timezone you selected for the "From" field is the "winter" 
                        or "summer" version,the "To" menu will only include the timezones of that variation,in order to prevent 
                        converting from a "summer" timezone to a "winter" one,which could cause confusion and unexpected issues.
                    </p>
                    <h3>24-hour or AM/PM</h3>
                    <p>At the very top there's the 24-hour checkbox.When checking it,the AM/PM selection will disappear and the 
                        "Hour" field will expand with 12 new values - 0 and 13-23.When unchecking 24-hour mode while the value under 
                        "Hour" is 0 or a value larger than 12,it will change to the AM/PM equivalent,same vice-versa.
                    </p>
                </section>
                <section id="unit-converter">
                    <h2>Unit converter</h2>
                    <p>This is the most straightforward and no catch converter of units of time.I features a considerable selection 
                        of units of time.The relationships between the units follow the <a href="#iso-standard">ISO Standard</a>.
                    </p>
                </section>
            </article>
        </main>
        <info-footer />
    </div>
</template>

<script setup>
  import { ref,computed,onMounted, onUnmounted } from "vue";
  import SidebarNavigator from "./SidebarNavigator.vue";
  import InfoFooter from "./InfoFooter.vue";
  import NavigationBar from "./NavigationBar.vue";
  import { timeCalculatorSettings } from "@/stores/TimeCalculatorStore";

  var isLight = computed(() => timeCalculatorSettings().lightMode);
  var isMenuShown = ref(false);

  const changeTheme = () =>
  {
    timeCalculatorSettings().changeTheme();
  }

  const toggleMenuMobile = () =>
  {
    isMenuShown.value = !isMenuShown.value;

    if(isMenuShown.value)
    {
      document.body.classList.add('menu-shown');
    }

    else
    {
      document.body.classList.remove('menu-shown');
    }
  }

  const changeToDesktop = () =>
  {
    if (window.innerWidth > 770) 
    {
        isMenuShown.value = false;
        document.body.classList.remove('menu-shown');
    }
  }

  onMounted(() => 
  {
    changeToDesktop();
    window.addEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });

  onUnmounted(() =>
  {
    window.removeEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Syne');
  [id]
  {
    scroll-margin-top: 70px;
  }
  
  #page
  {
    display: grid;
    min-height:100dvh;
    width:100vw;
    padding:0;
    margin:0;
    grid-template-columns: 1fr;
    grid-template-rows:67px auto 50px;
  }

  #page.lightmode
  {
    background-color: #F0F0F0;
  }

  #page.darkmode
  {
    background-color: #2b3133;
  }

  .darker-film
  {
    grid-area: 1 / 1 / -1 / 2;
    z-index:6;
    background-color: rgba(128, 128, 128, 0.4);
    transition: 0.1s all;
  }

  h1
  {
    margin-bottom:0;
  }

    main
    {
        grid-area: 2 / 1 / 3 / 2;
        font-family: Syne;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        justify-self:center;
        flex-grow: 1;
        width:92%;
        max-width: 600px;
        padding:1.333% 2%;
        margin:0 auto;
    }

    main.lightmode
    {
        background-color: #F7F7F6;
        color:#2b3133;
        box-shadow:#2b3133 0px 1px 7px 1px;
        -webkit-box-shadow:#2b3133 0px 1px 7px 1px;
    }

    main.darkmode
    {
        background-color: #2b3133;
        color: #F7F7F6;
        box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
        -webkit-box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
    }

    table
    {
        font-size: clamp(8px,4.5vw,20px);
    }

    table,th,td
    {
        border:1px solid;
        border-collapse: collapse;
    }

    table.lightmode,th.lightmode,td.lightmode
    {
        border-color: #2b3133;
    }

    table.darkmode,th.darkmode,td.darkmode
    {
        border-color: #F7F7F6;
    }

    a,a:visited
    {
        color:#328E6E;
    }

  @media screen and (min-width: 770px)
  {
    #page
    {
      width: 100vw;
      grid-template-columns: 100vw;
    }
  }
</style>